import React from 'react';

const TOEFLStudyPage = ({ onBack, userPreferences }) => {
  const getText = (textObj) => {
    return textObj[userPreferences.displayLanguage] || textObj.traditional;
  };

  const texts = {
    title: {
      traditional: 'TOEFL 學習',
      simplified: 'TOEFL 学习',
      english: 'TOEFL Study'
    },
    subtitle: {
      traditional: '托福英語考試準備',
      simplified: '托福英语考试准备',
      english: 'Test of English as a Foreign Language Preparation'
    },
    description: {
      traditional: '專為TOEFL考試設計的完整學習課程，提升學術英語能力。',
      simplified: '专为TOEFL考试设计的完整学习课程，提升学术英语能力。',
      english: 'Complete learning course designed for TOEFL exam, enhancing academic English proficiency.'
    },
    back: {
      traditional: '返回',
      simplified: '返回',
      english: 'Back'
    }
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-purple-900 via-blue-900 to-indigo-900 text-white">
      {/* Header */}
      <div className="flex items-center justify-between p-6">
        <button
          onClick={onBack}
          className="text-blue-400 hover:text-blue-300 transition-colors"
        >
          ← {getText(texts.back)}
        </button>
        <h1 className="text-xl font-bold">{getText(texts.title)}</h1>
        <div className="w-8"></div>
      </div>

      {/* Content */}
      <div className="px-6">
        <div className="bg-gray-800/30 rounded-xl p-6 mb-6">
          <h2 className="text-2xl font-bold mb-2">{getText(texts.subtitle)}</h2>
          <p className="text-gray-300 mb-4">{getText(texts.description)}</p>
          
          {/* Placeholder content */}
          <div className="grid grid-cols-2 gap-4">
            <div className="bg-gray-700/50 rounded-lg p-4">
              <h3 className="font-semibold mb-2">👂 聽力</h3>
              <p className="text-gray-300 text-sm">學術講座與校園對話</p>
            </div>
            
            <div className="bg-gray-700/50 rounded-lg p-4">
              <h3 className="font-semibold mb-2">🗣️ 口說</h3>
              <p className="text-gray-300 text-sm">獨立與綜合口說任務</p>
            </div>
            
            <div className="bg-gray-700/50 rounded-lg p-4">
              <h3 className="font-semibold mb-2">📖 閱讀</h3>
              <p className="text-gray-300 text-sm">學術文章與段落理解</p>
            </div>
            
            <div className="bg-gray-700/50 rounded-lg p-4">
              <h3 className="font-semibold mb-2">✍️ 寫作</h3>
              <p className="text-gray-300 text-sm">獨立與綜合寫作任務</p>
            </div>
          </div>
        </div>

        {/* TOEFL Specific Features */}
        <div className="bg-gray-800/30 rounded-xl p-6 mb-6">
          <h3 className="text-lg font-semibold mb-4">🎯 TOEFL 特色功能</h3>
          <div className="space-y-3">
            <div className="flex items-center space-x-3">
              <div className="w-8 h-8 bg-blue-500/20 rounded-full flex items-center justify-center">
                <span className="text-blue-400">📝</span>
              </div>
              <span className="text-gray-300">學術詞彙強化</span>
            </div>
            <div className="flex items-center space-x-3">
              <div className="w-8 h-8 bg-green-500/20 rounded-full flex items-center justify-center">
                <span className="text-green-400">🎧</span>
              </div>
              <span className="text-gray-300">筆記技巧訓練</span>
            </div>
            <div className="flex items-center space-x-3">
              <div className="w-8 h-8 bg-yellow-500/20 rounded-full flex items-center justify-center">
                <span className="text-yellow-400">⏱️</span>
              </div>
              <span className="text-gray-300">時間管理練習</span>
            </div>
            <div className="flex items-center space-x-3">
              <div className="w-8 h-8 bg-purple-500/20 rounded-full flex items-center justify-center">
                <span className="text-purple-400">🎯</span>
              </div>
              <span className="text-gray-300">模擬考試系統</span>
            </div>
          </div>
        </div>

        {/* Score Target */}
        <div className="bg-gray-800/30 rounded-xl p-6 mb-6">
          <h3 className="text-lg font-semibold mb-4">🎯 目標分數</h3>
          <div className="text-center">
            <div className="text-4xl font-bold text-green-400 mb-2">100</div>
            <p className="text-gray-300 text-sm">目標 TOEFL iBT 分數</p>
          </div>
        </div>

        {/* Coming Soon Notice */}
        <div className="text-center py-8">
          <div className="bg-blue-500/20 border border-blue-500/50 rounded-lg p-6">
            <h3 className="text-lg font-semibold mb-2">🚧 開發中</h3>
            <p className="text-gray-300">
              {userPreferences.displayLanguage === 'traditional' ? '此功能正在開發中，敬請期待！' :
               userPreferences.displayLanguage === 'simplified' ? '此功能正在开发中，敬请期待！' :
               'This feature is under development. Stay tuned!'}
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TOEFLStudyPage;
